<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import type { ContactPointReviewRow, ContactPointReviewDraft } from "../../contract"
  import { ContactComparisonTag } from "../../../../../../_shared/_modules/contact-comparison-tag"
  import { comparison } from "../../_shared/_logic/comparison"
  let {
    row,
    draft,
    columnConfig,
  }: InboxWorkflowCellProps<ContactPointReviewRow, ContactPointReviewDraft> = $props()
</script>
<ContactComparisonTag value={comparison(row, draft, columnConfig.id === "previousContact")} />
